import { atom } from "recoil";
import { IUserData } from "@/widgets/settings-users/users/interface/employee";
import {
  EMPTY_LINE_ASSIGNMENT_ERRORS,
  ILineAssignmentErrors,
} from "@/widgets/settings-users/users/utils/validate-line-assignments";

export const initState: IUserData = {
  username: "",
  password: "",
  roleID: "",
  email: "",
  isCanLoginWithCode: false,
  allowedIPs: [],
  linesOfBusiness: [],
  employee: {
    agentCode: null,
    additionProfits: null,
    firstname: null,
    lastname: null,
    phone: null,
    email: null,
    isActive: false,
    isWorkingOnCommonBoard: null,
    isHaveFullKanbanPermission: false,
    pinCode: null,
    isAgent: false,
    isCustomerSupportRepresentative: false,
    isGraphicArtist: false,
    isCourier: null,
    mailService: null,
    mailServicePassword: "",
    creationDate: new Date(),
    mailProviderId: null,
    smsTemplatesGroupId: null,
    quoteLimitationType: null,
    quotePriceLimit: null,
    pinCodeForLoginWithApplication: null,
    actionIds: [],
    stationsFilter: [],
  },
};
export const employeeState = atom<IUserData>({
  key: "employeeState",
  default: initState,
});

/** Inline errors of the lines/roles selector in the add/edit employee modal. */
export const employeeLineErrorsState = atom<ILineAssignmentErrors>({
  key: "employeeLineErrorsState",
  default: EMPTY_LINE_ASSIGNMENT_ERRORS,
});
